import { Injectable } from '@angular/core';
import { ApiHttp } from '../providers';
import { MessageService } from 'primeng/api';

@Injectable()
export class TODAService {
    constructor(private apiHttp: ApiHttp) {
    }

    public getTODAs(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/XpressTODA/GetTODAs', data, messageService);
    }
}
